import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import Banners from "./Banners";
import BannersManager from "./BannersManager";


class BannersPage extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.manageBanners}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.categories_banner}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.categories_banner}/>
                            }>
                            <BannersManager position="categories_banner"/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.product_page_banner}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.product_page_banner}/>
                            }>
                            <BannersManager position="product_page_banner"/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.product_inside_banner}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.product_inside_banner}/>
                            }>
                            <BannersManager position="product_inside_banner" limit={2}/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.home_top_banners}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.home_top_banners}/>
                            }>
                            <BannersManager position="home_top_banners"/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.home_single_banners}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.home_single_banners}/>
                            }>
                            <BannersManager position="home_single_banners" limit={2}/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.home_right_banners}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.home_right_banners}/>
                            }>
                            <BannersManager position="home_right_banners" />
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.home_left_banners}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.home_left_banners}/>
                            }>
                            <BannersManager position="home_left_banners"/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(BannersPage));
